import React from "react";
import BlueHeading from "../other/common/BlueHeading";
import Heading from "../common/ui/Heading";
const MediaHero = () => {
  return (
    <>
      <div className="bg-media-hero-bg bg-cover bg-center bg-no-repeat px-4">
        <div className="max-w-[1140px] mx-auto py-[242px] max-xl:py-44 max-lg:py-32 max-md:py-24 max-sm:py-14">
          <div>
            <BlueHeading
              text="Media"
              textClass="text-white"
              lineClassOne="!bg-white"
              lineClassTwo="!bg-white"
              className="max-sm:justify-center"
            />
            <Heading
              children="Media & Interviews"
              className="text-white max-w-[420px] max-sm:text-center"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MediaHero;
